const DEFAULT_CONFIG = {
  API_BASE_URL: 'http://localhost:8000/',
  TIMEOUT: 10000,
  RETRY_COUNT: 3,
  DEBUG: true
};

export function getAppConfig() {
  let config = DEFAULT_CONFIG;
  
  try {
    // 优先使用window.APP_CONFIG（H5环境）
    if (typeof window !== 'undefined' && window.APP_CONFIG) {
      config = { ...DEFAULT_CONFIG, ...window.APP_CONFIG };
    }
    // 其次使用app.globalData.config（小程序环境）
    else if (typeof getApp === 'function') {
      const app = getApp();
      if (app && app.globalData && app.globalData.config) {
        config = { ...DEFAULT_CONFIG, ...app.globalData.config };
      }
    }
  } catch (e) {
    		// 获取应用配置失败，使用默认配置
  }
  
  // 确保API_BASE_URL不为空
  if (!config.API_BASE_URL) {
    config.API_BASE_URL = DEFAULT_CONFIG.API_BASE_URL;
  }
  
  return config;
}

export function getApiBaseUrl() {
  return getAppConfig().API_BASE_URL;
}

export function isDebugMode() {
  return getAppConfig().DEBUG;
} 